import { render, staticRenderFns } from "./MemoForm.vue?vue&type=template&id=32e54c34&scoped=true&lang=pug&"
import script from "./MemoForm.vue?vue&type=script&lang=js&"
export * from "./MemoForm.vue?vue&type=script&lang=js&"
import style0 from "./MemoForm.vue?vue&type=style&index=0&id=32e54c34&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32e54c34",
  null
  
)

export default component.exports